import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function RightArrowIcon(props) {
  return (
    <SvgIcon viewBox="0 0 16 17" {...props}>
      <path d="M6.11959e-07 9.13183L12.17 9.13184L6.58 14.7218L8 16.1318L16 8.13184L8 0.131835L6.59 1.54183L12.17 7.13184L7.86805e-07 7.13183L6.11959e-07 9.13183Z" />
    </SvgIcon>
  );
}

export default RightArrowIcon;
